import React from "react";
import { styled } from "@mui/material/styles";
import {
  Create as BaseCreate,
  SimpleForm,
  TextInput,
  required,
  ReferenceArrayInput,
  SelectArrayInput,
  useDataProvider,
  useNotify,
} from "react-admin";
import Map from "../../components/Map";
import { updateOnboardingStep } from "../../components/dataProvider";
import { useContext } from "react";
import { OnboardingContext } from "../../contexts/OnboardingContext";
const PREFIX = "Create";

const classes = {
  inlineBlock: `${PREFIX}-inlineBlock`,
};

const StyledBaseCreate = styled(BaseCreate)({
  [`& .${classes.inlineBlock}`]: {
    display: "inline-flex",
    marginRight: "1rem",
  },
});

export const Create = (props) => {
  const notify = useNotify();

  const dataProvider = useDataProvider();
  const { setOnboardingSteps, onboardingSteps, checkAndTriggerOnboarding } = useContext(OnboardingContext);
  const handleSave = async (values, redirect) => {
    try {
      // Primero crea la sucursal
      await dataProvider.create("enterprise/branches", { data: values });
      // Luego actualiza el onboarding step 5
      const profile = JSON.parse(localStorage.getItem("profile") || "{}");
      const userId = profile?._id;
      // const resp = await updateOnboardingStep({ userId: userId, step: 5 });
      // setOnboardingSteps(resp.data ?? []);
      await updateOnboardingStep(
        { userId: userId, step: 5 },
        { setOnboardingSteps, checkAndTriggerOnboarding, onboardingSteps }
      );
      // Mostrar notificación de éxito
      notify("Sucursal creada exitosamente", { type: "success" });

      // Redireccionar al listado de sucursales
      redirect("/enterprise/branches");
    } catch (err) {
      if (err?.status && err.status >= 400) {
        alert("Error creando la sucursal o el onboarding, intenta de nuevo.");
      }
    }
  };
  return (
    <StyledBaseCreate {...props}>
      <SimpleForm onSubmit={handleSave} data-cy="branch-create-form">
        <div data-cy="branch-name">
          <TextInput validate={[required()]} source="name" label="Nombre" data-tour="sucursal-nombre" />
        </div>
        <div data-tour="sucursal-mapa">
          <Map source="addressInfo" />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }} data-tour="sucursal-bloque">
          <div data-cy="branch-street">
            <TextInput validate={[required()]} source="addressInfo.street" label="Calle" />
          </div>
          <div data-cy="branch-phone">
            <TextInput source="addressInfo.phone" label="Teléfono/Celular" />
          </div>
          <div data-cy="branch-services">
            <ReferenceArrayInput
              source="services"
              reference="service"
              filter={{
                method: "Ambos,En sucursal",
                enabled: true,
              }}
            >
              <SelectArrayInput label="Servicios" />
            </ReferenceArrayInput>
          </div>
        </div>
      </SimpleForm>
    </StyledBaseCreate>
  );
};
